import React, { FC } from 'react'
import { Box } from 'transfix-ui/core'
import { ITooltipProps, Tooltip } from 'transfix-ui'

export interface IEllipsisTooltipTextProps {
  text: string
  /**
   * @default 35
   */
  maxCharacters?: number
  /**
   * @default '...'
   */
  suffix?: string
  TooltipProps?: Omit<ITooltipProps, 'trigger'>
}

export const EllipsisTooltipText: FC<IEllipsisTooltipTextProps> = ({
  maxCharacters = 35,
  suffix = '...',
  text,
  TooltipProps = {},
}) => {
  const suffixLength = suffix.length
  const textBoundary = maxCharacters - suffixLength

  if (text.length <= maxCharacters) {
    return <Box component='span'>{text}</Box>
  }

  const textSliced = `${text.slice(0, textBoundary)}${suffix}`

  return (
    <Tooltip {...TooltipProps} trigger={<Box>{textSliced}</Box>}>
      <div>{text}</div>
    </Tooltip>
  )
}
